// ตัวละคร: ตัวช่วยร่วม (การ์ด/สิทธิ์ดู/prompt แยกโหนด) — พอร์ตจาก Content.gs
//  /characters/<id>        ข้อมูลสาธารณะ (ไม่มี description) ; /character_prompts/<id> = { description } (prompt ให้ AI)
import { fb, fk, rowsOf, getRow, memoize, dropMemo, pick, num, nowIso, err } from "./core";

export const cardOf = (c) =>
  pick(c, ["id", "name", "tagline", "image", "tagIds", "contentRating", "flag", "baseLanguage", "chatCount", "messageCount",
    "likeCount", "giftCount", "shareCode", "createdBy", "creatorName", "isFeatured", "createdAt"]);

export const getCharacter = (id) => (id ? getRow(`characters/${fk(id)}`) : Promise.resolve(null));

export async function getPrompt(id) {
  const p = await fb.get(`character_prompts/${fk(id)}`);
  return (p && p.description) || "";
}

export function canSeeCharacter(ch, uid, isSuper) {
  if (!ch) return false;
  if (isSuper || ch.createdBy === uid) return true;
  return ch.status === "approved" && ch.visibility !== "private";
}

/** การ์ดของตัวละครที่เผยแพร่ (cache 60 วินาที ; ล้างเมื่อสร้าง/แก้/อนุมัติ) */
export const charCards = () =>
  memoize("chars:cards", 60 * 1000, async () => {
    const rows = rowsOf(await fb.get("characters", { orderBy: "status", equalTo: "approved" }));
    return rows.filter((x) => x.status === "approved" && x.visibility === "public" && x.isArchived !== true).map(cardOf);
  });
export const dropCards = () => {
  dropMemo("chars:");
  dropMemo("creators:");
};

export const trendScore = (c) => {
  const ageDays = Math.max(0, (Date.now() - new Date(c.createdAt).getTime()) / 86400000);
  return (num(c.chatCount) * 2 + num(c.likeCount) * 3 + num(c.messageCount) * 0.1 + num(c.giftCount) * 5) / Math.sqrt(ageDays + 2);
};

export async function newShareCode() {
  const chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZ23456789";
  for (let t = 0; t < 30; t++) {
    let s = "";
    for (let i = 0; i < 7; i++) s += chars.charAt(Math.floor(Math.random() * chars.length));
    if (await fb.createOnly(`share_codes/${s}`, { at: nowIso() })) return s; // จองโค้ดก่อน (ผูก id ทีหลัง)
  }
  throw err("error", "สร้างโค้ดแชร์ไม่สำเร็จ ลองใหม่");
}
